export const anchorLinks = [
  {
    anchor: 'team',
    alias: '#team',
    title: 'Speakers',
  },
  {
    anchor: 'program',
    alias: '#program',
    title: 'Program',
  },
  {
    anchor: 'address',
    alias: '#address',
    title: 'How to find us',
  },
];
